module.exports = __webpack_public_path__ + "01_cheek.242d6edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer3/01_cheek.png
// module id = pxZ2
// module chunks = 0